import React, { useEffect, useState } from "react";
import "./ToolTip.scss";

const ToolTip = ({
  message = "",
  isActive = false,
  clearIndex = null,
  icon
}: any) => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(isActive);
    let id: any = null;
    if (clearIndex) {
      id = setTimeout(() => {
        setShow(false);
        clearIndex();
      }, 3000);
    }
    return () => {
        id && clearTimeout(id);
    };
  }, [isActive]);
  return (
    <div
      data-testid={"tooltip"}
      className={show ? "tooltip-container active" : "tooltip-container"}
    >
      <div className="tooltip">
      {icon && <p className="message-text">
        { icon}
        </p>}
        <div>
        <p className="message-text">{message}</p>
        </div>
      </div>
    </div>
  );
};

export { ToolTip };
